// lucidius-catalog-menu
{

if (!window.lucidiusCatalogBound) {
  window.lucidiusCatalogBound = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  const branches = nav => nav.querySelectorAll(':scope > .lucidius-catalog__list > li > details');
  const closeBranches = (nav, keep) => branches(nav).forEach(details => { if (details !== keep) details.open = false; });
  const closeSub = (item, focus) => {
    item.classList.remove('is-open');
    const drill = item.querySelector(':scope > .lucidius-catalog__drill');
    drill.setAttribute('aria-expanded', 'false');
    if (focus) drill.focus();
  };
  // Desktop hover. A row opens its panel once the mouse has been on it for 150 ms;
  // moving within the row does not restart the wait. If the mouse is still going
  // faster than 200 px/s by then, it is crossing the bar, and the panel waits until
  // it slows down. With a panel open, the next row takes over at once, unless the
  // mouse is heading into the open panel (down from a bar of categories, right of a
  // vertical list) by more than a hand's jitter, or has moved too little since it
  // was still to tell: then the switch waits until the mouse stops for 100 ms, turns
  // away or has been 300 ms on the row, so a diagonal move into the panel keeps it.
  // Leaving the menu closes the panel after 400 ms. Only real mouse movement counts,
  // so content scrolling under a still pointer opens nothing.
  const OPEN = 150;
  const SETTLE = 20;
  const REST = 100;
  const AIM = 300;
  const CLOSE = 400;
  const JITTER = 6;
  const TRAVEL = 40;
  let timer = 0;
  let closer = 0;
  let hovered = null;
  let aiming = 0;
  let pointer = '';
  // Mouse positions since it was last still, at most the last 300 ms plus the one
  // before them.
  const trail = [];
  const show = (nav, row) => {
    clearTimeout(timer);
    aiming = 0;
    const details = row.querySelector(':scope > details');
    closeBranches(nav, details);
    if (details) details.open = true;
  };
  // Opens the row's panel unless the mouse moved more than SETTLE px in the last
  // 100 ms; then checks again shortly.
  const settle = (nav, row) => {
    const now = performance.now();
    const last = trail[trail.length - 1];
    const before = trail.filter(point => point.t <= now - 100).pop() || trail[0];
    if (Math.hypot(last.x - before.x, last.y - before.y) <= SETTLE) show(nav, row);
    else timer = setTimeout(() => settle(nav, row), 50);
  };
  // Whether the mouse may be heading into the open panel: over its last TRAVEL px it
  // moved more than JITTER px towards the panel, on a line that meets the panel's
  // near edge. With less travel since it was still, any move towards it counts.
  const heading = (open, to) => {
    let from = trail[0];
    for (let i = trail.length - 2; i > 0; i--) {
      if (Math.hypot(to.x - trail[i].x, to.y - trail[i].y) >= TRAVEL) {
        from = trail[i];
        break;
      }
    }
    const panel = open.lastElementChild.getBoundingClientRect();
    const below = panel.top >= open.parentElement.getBoundingClientRect().bottom - 1;
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const toward = below ? dy : dx;
    if (Math.hypot(dx, dy) < TRAVEL) return toward > 0;
    if (toward <= JITTER) return false;
    if (below) {
      const x = from.x + dx * (panel.top - from.y) / dy;
      return x >= panel.left && x <= panel.right;
    }
    const y = from.y + dy * (panel.left - from.x) / dx;
    return y >= panel.top && y <= panel.bottom;
  };
  document.addEventListener('pointerdown', event => { pointer = event.pointerType; }, true);
  document.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || !desktop.matches) return;
    const point = {x: event.clientX, y: event.clientY, t: performance.now()};
    // After a pause of more than 50 ms the trail restarts where the mouse rested.
    if (point.t - trail[trail.length - 1]?.t > 50) trail.splice(0, trail.length - 1);
    trail.push(point);
    while (trail.length > 2 && point.t - trail[1].t >= 300) trail.shift();
    const nav = event.target.closest('.lucidius-catalog');
    if (!nav) return;
    clearTimeout(closer);
    const row = event.target.closest('.lucidius-catalog__row');
    if (row === hovered && !aiming) return;
    const open = nav.querySelector(':scope > .lucidius-catalog__list > li > details[open]');
    if (row !== hovered) {
      hovered = row;
      clearTimeout(timer);
      aiming = 0;
      if (!row || open?.parentElement === row) return;
      if (!open) {
        if (row.querySelector(':scope > details')) timer = setTimeout(() => settle(nav, row), OPEN);
        return;
      }
      if (!heading(open, point)) return show(nav, row);
      aiming = point.t;
    } else if (!open) {
      clearTimeout(timer);
      aiming = 0;
      return;
    } else if (point.t - aiming >= AIM || !heading(open, point)) return show(nav, row);
    clearTimeout(timer);
    timer = setTimeout(() => show(nav, row), REST);
  }, {passive: true});
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse' || !desktop.matches) return;
    const nav = event.target.closest('.lucidius-catalog');
    if (!nav || nav.contains(event.relatedTarget)) return;
    clearTimeout(timer);
    clearTimeout(closer);
    hovered = null;
    aiming = 0;
    if (!nav.contains(document.activeElement)) closer = setTimeout(() => closeBranches(nav), CLOSE);
  });
  document.addEventListener('focusout', event => {
    if (!desktop.matches) return;
    const row = event.target.closest('.lucidius-catalog__row');
    if (row && !row.contains(event.relatedTarget)) row.querySelector(':scope > details[open]')?.removeAttribute('open');
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('.lucidius-catalog__branch')) return;
    if (!details.open) {
      details.querySelectorAll('.lucidius-catalog__item.is-open').forEach(item => closeSub(item, false));
      return;
    }
    closeBranches(details.closest('.lucidius-catalog'), details);
    if (!desktop.matches && details.closest('.catalog-bar--ready')) details.querySelector('.lucidius-catalog__panel [data-catalog-back]')?.focus();
  }, true);
  document.addEventListener('click', event => {
    const summary = event.target.closest('.lucidius-catalog__toggle');
    // A mouse click on an already open panel's arrow keeps it open; leaving the menu closes it.
    if (summary) {
      if (desktop.matches && pointer === 'mouse' && event.detail && summary.parentElement.open) event.preventDefault();
      return;
    }
    const drill = event.target.closest('.lucidius-catalog__drill');
    if (drill) {
      const item = drill.closest('.lucidius-catalog__item');
      drill.closest('.lucidius-catalog__panel').scrollTop = 0;
      item.classList.add('is-open');
      drill.setAttribute('aria-expanded', 'true');
      item.querySelector('.lucidius-catalog__sub [data-catalog-back]')?.focus();
      return;
    }
    const back = event.target.closest('[data-catalog-back]');
    if (!back) return;
    const item = back.closest('.lucidius-catalog__item.is-open');
    if (item) {
      closeSub(item, true);
      return;
    }
    const details = back.closest('.lucidius-catalog__branch');
    details.open = false;
    details.querySelector(':scope > summary').focus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const nav = event.target.closest?.('.lucidius-catalog');
    if (!nav) return;
    const item = nav.querySelector('.lucidius-catalog__item.is-open');
    const details = nav.querySelector(':scope > .lucidius-catalog__list > li > details[open]');
    if (item) closeSub(item, true);
    else if (details) {
      details.open = false;
      details.querySelector(':scope > summary').focus();
    } else return;
    // A pending hover does not reopen what Escape closed.
    clearTimeout(timer);
    aiming = 0;
    event.preventDefault();
  });
}

}

// lucidius-account-drawer
{

(() => {
  const panel = document.getElementById('LucidiusAccount');
  if (!panel) return;
  let trigger;
  const tabs = [...panel.querySelectorAll('[data-account-tab]')];
  const select = (tab, focus = false) => {
    tabs.forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected);
      item.tabIndex = selected ? 0 : -1;
      document.getElementById(item.dataset.accountTab).hidden = !selected;
    });
    document.getElementById('AccountRecover').hidden = true;
    if (focus) tab.focus();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-account-drawer-trigger]');
    if (!link) return;
    event.preventDefault(); trigger = link; select(tabs[0]);
    panel.showModal(); document.body.classList.add('overflow-hidden');
    trapFocus(panel, panel.querySelector('[data-account-close]'));
  });
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      select(tabs[next], true);
    });
  });
  panel.querySelector('[data-account-close]').addEventListener('click', () => panel.close());
  panel.addEventListener('click', event => { if (event.target === panel) { const rect = panel.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close(); } });
  panel.addEventListener('close', () => { document.body.classList.remove('overflow-hidden'); removeTrapFocus(trigger); });
  panel.querySelector('[data-account-recover]').addEventListener('click', () => {
    document.getElementById('AccountLogin').hidden = true;
    document.getElementById('AccountRecover').hidden = false;
    document.getElementById('AccountRecoverEmail').focus();
  });
  panel.querySelector('[data-account-back]').addEventListener('click', () => select(tabs[0], true));
})();

}

// lucidius-withdrawal-trigger
{

(() => {
  const roots = new WeakSet();
  let pending = false;
  let contentObserver;
  let observedTargets = [];
  let observedBand = '';
  let contentOverlap = false;
  const overlaps = new Set();
  const syncContentVisibility = () => {
    document.querySelectorAll('.widerruf-popup-source--embed').forEach(host => host.toggleAttribute('data-lucidius-content-overlap', contentOverlap));
  };
  const observeContent = () => {
    const mobile = matchMedia('(max-width:749px)').matches;
    const targets = mobile ? [...document.querySelectorAll('.lucidius-trust-strip li, product-info .product__sku, product-info .product__info-container .price, product-info .product-form__submit, product-info .product-form__quantity, .product-card-wrapper .card__information, .product-card-wrapper .quick-add')] : [];
    targets.push(...document.querySelectorAll('main .customer'));
    const stickyHeight = document.body.classList.contains('lucidius-sticky-atc-visible') ? parseFloat(document.body.style.getPropertyValue('--lucidius-sticky-atc-height')) || 90 : 0;
    const bottom = stickyHeight ? stickyHeight + 16 : 16;
    const band = `${Math.max(0, innerHeight - bottom - 44)}:${bottom}`;
    if (band === observedBand && targets.length === observedTargets.length && targets.every((target, i) => target === observedTargets[i])) return;
    contentObserver?.disconnect();
    observedTargets = targets;
    observedBand = band;
    overlaps.clear();
    contentOverlap = false;
    syncContentVisibility();
    if (!targets.length || !('IntersectionObserver' in window)) return;
    contentObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? overlaps.add(entry.target) : overlaps.delete(entry.target));
      contentOverlap = overlaps.size > 0;
      syncContentVisibility();
    }, {rootMargin:`-${Math.max(0, innerHeight - bottom - 44)}px 0px -${bottom}px 0px`});
    targets.forEach(target => contentObserver.observe(target));
  };
  const update = () => {
    pending = false;
    const locked = [...document.body.classList].some(name => name.startsWith('overflow-hidden'));
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const overlay = locked || !!document.querySelector('cart-drawer.active,dialog[open],modal-dialog[open],quick-add-modal[open],predictive-search[open],menu-drawer details[open]') || (!desktop && !!document.querySelector('.catalog-bar__menu[open]'));
    document.querySelectorAll('.widerruf-popup-source--embed').forEach(host => {
      const shadow = host.shadowRoot;
      if (!shadow) return;
      if (!roots.has(shadow)) {
        roots.add(shadow);
        const style = document.createElement('style');
        style.textContent = `:host([data-lucidius-overlay-open]) .widerruf-trigger-button--floating,:host([data-lucidius-content-overlap]) .widerruf-trigger-button--floating{display:none!important}
          .widerruf-trigger-button--floating{width:44px!important;min-width:44px!important;height:44px!important;padding:0!important;font-size:0!important;position:fixed!important;top:auto!important;bottom:max(16px,env(safe-area-inset-bottom))!important;left:max(16px,env(safe-area-inset-left))!important;right:auto!important;transform:none!important;margin:0!important;border-radius:50%!important}
          :host([data-lucidius-sticky-visible]) .widerruf-trigger-button--floating.widerruf-trigger-button--floating{bottom:calc(var(--lucidius-withdrawal-sticky-height,0px) + max(16px,env(safe-area-inset-bottom)))!important}
          .widerruf-trigger-button--floating::before{content:"";display:block;width:22px;height:22px;background:center/22px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M9 5 4 10l5 5M4 10h9a6 6 0 0 1 0 12'/%3E%3C/svg%3E")}`;
        const trigger = shadow.querySelector('.widerruf-trigger-button--floating');
        if (trigger) trigger.title = trigger.textContent.trim();
        shadow.appendChild(style);
        new MutationObserver(schedule).observe(shadow, {subtree:true,childList:true,attributes:true,attributeFilter:['hidden','aria-hidden','class']});
      }
      const sticky = document.querySelector('mobile-sticky-atc');
      const stickyVisible = matchMedia('(max-width:749px)').matches && document.body.classList.contains('lucidius-sticky-atc-visible') && sticky && !sticky.hidden;
      host.toggleAttribute('data-lucidius-sticky-visible', !!stickyVisible);
      host.style.setProperty('--lucidius-withdrawal-sticky-height', stickyVisible ? `${sticky.getBoundingClientRect().height}px` : '0px');
      const ownModal = !!shadow.querySelector('.widerruf-popup-modal:not([hidden])');
      host.toggleAttribute('data-lucidius-overlay-open', overlay || ownModal);
      host.toggleAttribute('data-lucidius-content-overlap', contentOverlap);
    });
    observeContent();
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  new MutationObserver(schedule).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden','aria-hidden']});
  window.matchMedia('(min-width: 990px)').addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive:true});
  schedule();
})();

}

// product-media-modal
{

  // Hidden zoom images have no src/srcset: request them only when this modal opens.
  document.querySelectorAll('product-modal').forEach((modal) => {
    const observer = new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;
      modal.querySelectorAll('img[data-zoom-src]').forEach((image) => {
        image.srcset = image.dataset.zoomSrcset;
        image.src = image.dataset.zoomSrc;
        image.removeAttribute('data-zoom-src');
        image.removeAttribute('data-zoom-srcset');
      });
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  });

}
